module.exports = __webpack_public_path__ + "static/img/366.f4c5896c.png";